import React, { useEffect, useRef } from 'react';

import { useField } from '@unform/core';
import { Box, FormControlLabel, Radio as MUIRadio, RadioGroup } from '@material-ui/core';

export default function Radio({ name = '', options = [], ...rest }) {
  const inputRefs = useRef([]);

  const { fieldName, defaultValue, registerField, error, clearError } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRefs.current,
      path: 'value',
      getValue(refs) {
        const checked = refs.find((ref) => ref.checked);
        return checked ? checked.value : null;
      },
      setValue(refs, value) {
        const item = refs.find((ref) => ref.value === value);

        if (item) {
          item.checked = true;
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <>
      <RadioGroup row name={name} defaultValue={`${defaultValue}`} {...rest}>
        {options.map(({ label, value, id, ...opts }, index) => (
          <FormControlLabel
            key={index}
            inputRef={(elRef) => (inputRefs.current[index] = elRef)}
            control={<MUIRadio id={id} color="primary" onClick={clearError} />}
            label={label}
            value={`${value}`}
            {...opts}
          />
        ))}
      </RadioGroup>
      {Boolean(error) && (
        <Box fontSize={12} color="error.main">
          {error}
        </Box>
      )}
    </>
  );
}
